{
  "items": [
    { "label": "UMSKAL" },
    { "label": "UMP" },
    { "label": "UTM" },
    { "label": "UKM" },
    { "label": "UNIMAS" },
    { "label": "More soon", "placeholder": true }
  ]
}
